'use client';

import type { ReactNode } from 'react';

import { createHeroThreeScene } from './hero-three-scene';
import { ProductMarkThreeOrnament } from './product-mark-three-ornament';

type HeroThreeOrnamentProps = {
  /** Static mark markup shown until (and unless) the WebGL scene is live. */
  children: ReactNode;
};

/**
 * Decorative Three.js geometric chip for the Kinetic hero right column.
 * Ported from docs/stitch/three-js.html. The SSR-rendered static children
 * paint on first load and stay when prefers-reduced-motion is set, WebGL is
 * unavailable, or the scene factory fails; the canvas cross-fades in once the
 * scene resolves. Scene creation lives in hero-three-scene.ts so `three`
 * stays out of the SSR/worker module graph until the client effect.
 */
export function HeroThreeOrnament({ children }: HeroThreeOrnamentProps) {
  return (
    <div className="h-[220px] w-full md:h-[360px]">
      <ProductMarkThreeOrnament createScene={createHeroThreeScene}>
        {children}
      </ProductMarkThreeOrnament>
    </div>
  );
}
